import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * A simple redirect page that takes users directly to the standalone brands explorer
 */
function BrandsExplorerRedirect() {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Set a very short timeout to ensure the component has mounted
    const timer = setTimeout(() => {
      navigate('/completely-public');
    }, 100);
    
    return () => clearTimeout(timer);
  }, [navigate]);
  
  return (
    <div style={{ 
      minHeight: '100vh', 
      backgroundColor: '#f3f4f6',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '2rem',
        borderRadius: '0.5rem',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        textAlign: 'center'
      }}>
        <div style={{ marginBottom: '1rem' }}>
          <div className="spinner" style={{
            display: 'inline-block',
            width: '40px',
            height: '40px',
            border: '4px solid rgba(0, 128, 128, 0.3)',
            borderRadius: '50%',
            borderTop: '4px solid #008080',
            animation: 'spin 1s linear infinite'
          }}></div>
          <style>{`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}</style>
        </div>
        <h2 style={{ fontSize: '1.25rem', fontWeight: '600' }}>Redirecting to Brands Explorer...</h2>
        <p style={{ marginTop: '0.5rem', color: '#4b5563' }}>
          If you are not redirected automatically, <a href="/completely-public" style={{ color: '#008080', textDecoration: 'underline' }}>click here</a>.
        </p>
      </div>
    </div>
  );
}

export default BrandsExplorerRedirect; 